import AccordionItemHandler from 'components/forms/new/AccordionItemHandler';

import PrimaryContactName from '../formFields/PrimaryContactName';
import PrimaryContactPhone from '../formFields/PrimaryContactPhone';
import PrimaryContactEmail from '../formFields/PrimaryContactEmail';
import AccountsContactEmail from '../formFields/AccountsContactEmail';
import SupportContactEmail from '../formFields/SupportContactEmail';
import BusinessNumber from '../formFields/BusinessNumber';

const PartnerGeneralContact = ({ errors, touched, darkMode }) => {
    const formFields = (errors, touched) => {
        const fields = [
            <PrimaryContactName
                key="primaryContactName"
                errors={errors}
                touched={touched}
                darkMode={darkMode}
            />,
            <PrimaryContactPhone
                key="primaryContactPhone"
                errors={errors}
                touched={touched}
                darkMode={darkMode}
            />,
            <PrimaryContactEmail
                key="primaryContactEmail"
                errors={errors}
                touched={touched}
                darkMode={darkMode}
            />,
            <AccountsContactEmail
                key="accountsContactEmail"
                errors={errors}
                touched={touched}
                darkMode={darkMode}
            />,
            <SupportContactEmail
                key="supportContactEmail"
                errors={errors}
                touched={touched}
                darkMode={darkMode}
            />,
            <BusinessNumber
                key="businessNumber"
                errors={errors}
                touched={touched}
                darkMode={darkMode}
            />,
        ];

        return fields;
    };

    const filteredFields = formFields(errors, touched).filter(Boolean);

    return (
        <AccordionItemHandler
            index={1}
            key="partnerGeneralContact"
            label="Contact Information"
            errors={errors}
            touched={touched}
            defaultIsOpen={false}>
            {filteredFields}
        </AccordionItemHandler>
    );
};

export default PartnerGeneralContact;
